import { render, staticRenderFns } from "./administration.vue?vue&type=template&id=06db59b7&scoped=true&"
import script from "./administration.vue?vue&type=script&lang=js&"
export * from "./administration.vue?vue&type=script&lang=js&"
import style0 from "./administration.vue?vue&type=style&index=0&id=06db59b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db59b7",
  null
  
)

export default component.exports